import { TranslationMessages } from '../types';
import { app } from './app/ru';
import { settingsApp } from './app/ru';

const ru: TranslationMessages = {
  nav: {
    howItWorks: 'Как это работает',
    why: 'Зачем?',
    features: 'Возможности',
    getStarted: 'НАЧАТЬ',
    dashboard: 'Панель управления',
    blog: 'Блог',
  },
  hero: {
    title1: 'Telegram Stars',
    title2: 'Получайте оплату легко',
    subtitle: 'Создавайте платёжные ссылки мгновенно, управляйте балансом и выводите в TON. Комиссия платформы 3%.',
    cta: 'Начать',
    hairsim: 'Симулируйте пересадку волос',
  },
  demo: {
    botName: 'Telegram Stars Bot',
    online: 'в сети',
    linkCreated: 'Платёжная ссылка создана.',
    invoiceTitle: 'Premium Access',
    invoiceDesc: 'Ежемесячная подписка',
    stars: 'Stars',
    payBtn: 'Оплатить 100 Stars',
    iPayNow: 'Оплачиваю сейчас',
    paymentLabel: 'Оплата Telegram Stars',
    merchant: 'Продавец',
    amount: 'Сумма',
    confirmPay: 'Подтвердить оплату',
    paymentReceived: 'Оплата получена — 100 Stars',
    invoiceCredited: 'Invoice #xk9m2 · зачислено на баланс',
    thanks: 'Спасибо, доступ активирован',
    messagePlaceholder: 'Сообщение',
  },
  stats: {
    title: 'Нам доверяют тысячи агентов',
    subtitle: 'Присоединяйтесь к растущему сообществу продавцов, использующих платежи Telegram Stars',
    activeAgents: 'Активные агенты',
    transactions: 'Транзакции',
    uptime: 'Доступность',
    support: 'Поддержка',
  },
  features: {
    title: 'Всё необходимое для приёма платежей Telegram Stars',
    subtitle: 'Полная платформа для управления платежами Telegram Stars',
    instantTitle: 'Мгновенное создание',
    instantDesc: 'Станьте агентом за секунды. Настройка не требуется.',
    balanceTitle: 'Управление балансом',
    balanceDesc: 'Отслеживайте доход в реальном времени с интуитивной панелью управления.',
    paymentsTitle: 'Платежи Telegram Stars',
    paymentsDesc: 'Принимайте платежи в Telegram Stars через вашего бота.',
    securityTitle: 'Максимальная безопасность',
    securityDesc: 'Неизменяемый реестр, безопасные и прозрачные транзакции.',
    withdrawTitle: 'Вывод в TON',
    withdrawDesc: 'Выводите средства напрямую на ваш TON-адрес.',
    apiTitle: 'Надёжный API',
    apiDesc: 'Простая интеграция с вебхуками и полноценным REST API.',
  },
  how: {
    title: 'Как это работает',
    subtitle: 'Начните в 3 простых шага',
    startDemo: 'Запустить демо',
    demoRunning: 'Демо запущено...',
    reset: 'Сбросить',
    step1Title: '1. Регистрация',
    email: 'Email',
    password: 'Пароль',
    noCard: '✓ Кредитная карта не требуется',
    step2Title: '2. Создание платёжных ссылок',
    amountStars: 'Сумма (Stars)',
    generatedLink: 'Сгенерированная ссылка:',
    shareLink: '✓ Поделитесь этой ссылкой с клиентами',
    step3Title: '3. Вывод средств',
    tonAddress: 'TON-адрес',
    availableBalance: 'Доступный баланс:',
    fee: 'Комиссия: 3%',
  },
  pricing: {
    title: 'Простые и прозрачные тарифы',
    subtitle: 'Без скрытых комиссий и обязательств',
    commission: 'Комиссия',
    perTransaction: 'за транзакцию',
    freeAccount: 'Бесплатное создание аккаунта',
    noMonthly: 'Без ежемесячной платы',
    tonWithdrawals: 'Интегрированный вывод в TON',
    completeDashboard: 'Полная панель управления',
    support247: 'Поддержка 24/7',
    startNow: 'Начать сейчас',
  },
  faq: {
    title: 'Часто задаваемые вопросы',
    subtitle: 'Всё, что нужно знать о платежах Telegram Stars',
    q1: 'Как работает оплата Telegram Stars?',
    a1: 'Оплата Telegram Stars позволяет продавцам принимать платежи напрямую через Telegram. Пользователи создают платёжные ссылки, делятся ими с клиентами и получают оплату в валюте Telegram Stars.',
    q2: 'Какова комиссия платформы?',
    a2: 'Комиссия платформы составляет 3% за транзакцию. Это покрывает обработку платежей, управление реестром и обслуживание платформы. Нет платы за настройку или ежемесячных расходов.',
    q3: 'Как вывести Telegram Stars?',
    a3: 'Вы можете запросить вывод на ваш TON-кошелёк. Выводы обрабатываются вручную для безопасности. Минимальный вывод — 100 Stars.',
    q4: 'Безопасна ли оплата Telegram Stars?',
    a4: 'Да, все платежи обрабатываются через защищённую платёжную систему Telegram. Мы используем стандартное шифрование и практики безопасности.',
    q5: 'Что такое Telegram Stars?',
    a5: 'Telegram Stars — виртуальная валюта в Telegram для платежей. Пользователи могут покупать Stars и использовать их для оплаты услуг, товаров и подписок.',
    q6: 'Могу ли я использовать платежи Telegram Stars для бизнеса?',
    a6: 'Да! Telegram Stars Payment Platform создана для продавцов, создателей и бизнеса. Вы можете принимать платежи за цифровые продукты, услуги, подписки и многое другое.',
  },
  cta: {
    title: 'Готовы начать?',
    subtitle: 'Присоединяйтесь к тысячам агентов, уже использующих нашу платформу',
    createAccount: 'Создать бесплатный аккаунт',
    signIn: 'Войти',
  },
  footer: {
    description: 'Полная SaaS-платформа для платежей Telegram Stars',
    product: 'Продукт',
    features: 'Возможности',
    pricing: 'Тарифы',
    support: 'Поддержка',
    signIn: 'Войти',
    docs: 'Документация',
    copyright: '© 2024 Telegram Stars Payment Platform. Все права защищены.',
  },
  seo: {
    title: 'Telegram Stars Payment Platform | Принимайте платежи через Telegram Stars',
    description: 'Принимайте платежи через Telegram Stars. Создавайте платёжные ссылки мгновенно, управляйте балансом и выводите в TON. Комиссия платформы 3%. Начните принимать платежи Telegram Stars сегодня.',
    keywords: 'telegram stars оплата, принимать telegram stars, telegram stars payment platform, платёжный шлюз telegram stars',
  },
  whyPage: {
    seoTitle: 'Почему Telegram Stars Payment Platform | Преимущества',
    seoDescription: 'Узнайте, почему продавцы и создатели выбирают Telegram Stars Payment Platform: мгновенная настройка, прозрачные тарифы, безопасные платежи и глобальный охват.',
    title: 'Почему мы?',
    subtitle: 'Создано для продавцов и создателей, которым нужны простые платежи Telegram Stars',
    r1Title: 'Мгновенная настройка',
    r1Desc: 'Начните за секунды. Не нужна сложная настройка или технические знания.',
    r2Title: 'Прозрачные тарифы',
    r2Desc: 'Только 3% за транзакцию. Без скрытых комиссий, ежемесячных расходов и платы за настройку.',
    r3Title: 'Безопасность и надёжность',
    r3Desc: 'Построено на защищённой платёжной инфраструктуре Telegram со стандартным шифрованием.',
    r4Title: 'Глобальный охват',
    r4Desc: 'Принимайте платежи от пользователей Telegram по всему миру. Без географических ограничений.',
    r5Title: 'Простая интеграция',
    r5Desc: 'Простой API и вебхуки. Интегрируйтесь с существующими системами за минуты.',
    r6Title: 'Вывод в TON',
    r6Desc: 'Выводите напрямую на ваш TON-кошелёк. Быстрые и безопасные выводы.',
  },
  howPage: {
    seoTitle: 'Как это работает | Telegram Stars Payment Platform',
    seoDescription: 'Узнайте, как принимать платежи через Telegram Stars в 3 простых шага. Создайте аккаунт, генерируйте платёжные ссылки и выводите в TON.',
    title: 'Как это работает',
    subtitle: 'Принимайте платежи Telegram Stars в три простых шага',
  },
  settings: {
    title: "Настройки",
    languageSection: "Язык",
    defaultLanguage: "Язык по умолчанию",
    languageHint: "Этот язык применяется ко всей платформе (лендинги и интерфейс).",
    languageSaved: "Язык обновлён",
    ...settingsApp,
  },
  app,
};

export default ru;
